import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import backArrow from "../../assets/task/back_arrow.svg";
import FeatureTab from "../../components/actions/FeatureTab";
import BreadCumb from "../../components/common/Breadcrumb";

const FeatureHistory: FunctionComponent = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full relative feature-history-dv overflow-hidden flex flex-col items-start justify-start min-w-[360px] max-w-[100%] leading-[normal] tracking-[normal] text-left text-xl text-colors-text-black font-body-xs-semi-bold mq450:max-w-full mq950:max-w-full mq1425:max-w-full mq1900:max-w-full">
            <div className="self-stretch bg-gray overflow-hidden flex flex-col items-center justify-start relative gap-[24px] min-h-[913px] max-w-full">
                <div className="w-full flex flex-col items-start justify-start py-40 px-20 mq1490:px-[30px] mq575:px-5 box-border gap-[24px] max-w-[100%]">
                    {/* Header */}
                    <BreadCumb />
                    <div className="self-stretch flex flex-row items-center justify-start gap-[5px] max-w-full">
                        <img
                            className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img"
                            alt=""
                            src={backArrow}
                            onClick={() => navigate("/actions")}
                        />
                        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">
                            Feature History
                        </h3>
                    </div>

                    {/* Feature Tab — full width on this dedicated page */}
                    <div className="w-full">
                        <FeatureTab heading="Feature History" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureHistory;
